/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from '@angular/core'
import {
  ResizeDirection,
  ResizeHandleComponent,
} from './resize-handle.component'

/**
 * This is used in tests that depend on NoLoadedAccountComponent
 */
@Component({
  selector: 'hs-resize-handle',
  template: '',
})
export class MockResizeHandleComponent
  implements Partial<ResizeHandleComponent>
{
  @Input() elem1?: HTMLElement
  @Input() elem2?: HTMLElement
  @Input() direction: ResizeDirection = ResizeDirection.Vertical
}
